import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar as CapacitorStatusBar, Style } from '@capacitor/status-bar';

const useStatusBar = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const init = async () => {
      if (Capacitor.getPlatform() === 'android') {
        await CapacitorStatusBar.setOverlaysWebView({ overlay: true });
      }
      await CapacitorStatusBar.setStyle({ style: Style.Default });
    };

    init().catch(() => {});
  }, []);
};

export const StatusBar = () => {
  useStatusBar();
  return null;
};
